import { FlightItem } from "booking_app/types";

export abstract class FlightItemFilter {
  abstract perform(flightItem: FlightItem): boolean;
  abstract reset(): void;
}
